import { createSlice } from '@reduxjs/toolkit';
import { Actividades } from 'generated/graphql';

const initialState: Partial<Actividades> = {};

const currentActividadStateSlice = createSlice({
	name: 'currentActividadState',
	initialState,
	reducers: {
		setCurrentActividadState: (state, action) => {
			return action.payload;
		},
		resetCurrentActividadState: () => {
			return initialState;
		}
	}
});

export const { setCurrentActividadState, resetCurrentActividadState } = currentActividadStateSlice.actions;
export default currentActividadStateSlice.reducer;
